import { gql } from '@apollo/client';

export const CREATE_OBJECT_MUTATION = gql`
  mutation CreateObjectMutation($object: ObjectInput!) {
    createObject(object: $object) {
      ... on CreateObjectSuccess {
        object {
          id
          createdAt
          updatedAt
          createdBy
          createdByName
          createdByEmail
          name
          description
          position
          geometry
          type
          siteId
          siteStatus
          groupId
          parentId
          parentName
          mapsVisible
          filled
          visibility
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
